import React from "react";
import GoogleMapReact from "google-map-react";

const defaultProps = {
  center: {
    lat: 58.434228,
    lng: 23.681867,
  },
  zoom: 8,
};

const renderMarker = (map, maps) =>
  new maps.Marker({
    position: defaultProps.center,
    map,
    title: "Varbla puhkeküla",
  });

const GoogleMap = () => (
  <div style={{ height: "60vh", width: "100%" }}>
    <GoogleMapReact
      bootstrapURLKeys={{ key: process.env.GOOGLE_MAPS_API_KEY }}
      defaultCenter={defaultProps.center}
      defaultZoom={defaultProps.zoom}
      yesIWantToUseGoogleMapApiInternals
      onGoogleApiLoaded={({ map, maps }) => renderMarker(map, maps)}
    />
  </div>
);

export default GoogleMap;
